/* eslint-disable max-len */

/* eslint-disable react/prop-types */
import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
const { OutlinedInput } = MaterialUiCore;
const { ListItemText } = MaterialUiCore;
const { Checkbox } = MaterialUiCore;
const { Select } = MaterialUiCore;
const { FormControl } = MaterialUiCore;
const { MenuItem } = MaterialUiCore;
const { InputLabel } = MaterialUiCore;

function SelectTextField(props) {
    const { label, filterName, updateParentState, options, ...rest } = props;
    const [textVal, setTextVal] = React.useState('');
    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const handleChange = (event) => {
        setTextVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <>
            <FormControl variant="outlined" className="fullWidth">
                <InputLabel ref={inputLabel} id="select-outlined-label">
                    {label}
                </InputLabel>
                <Select
                    labelId="select-outlined-label"
                    id="select-outlined"
                    value={textVal}
                    onChange={handleChange}
                    labelWidth={labelWidth}
                    {...rest}
                >
                    {options.map((option) => (
                        <MenuItem key={option.display.toUpperCase()} value={option.value}>
                            {option.display}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

function MultiSelectTextField(props) {
    const { label, filterName, updateParentState, options, ...rest } = props;
    const [multiVal, setMultiVal] = React.useState([]);
    const inputLabel = React.useRef(null);

    const handleChange = (event) => {
        setMultiVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <>
            <FormControl className="fullWidth">
                <Select
                    labelId="mutiple-checkbox-label"
                    id="mutiple-checkbox"
                    multiple
                    value={multiVal}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.join(', ')}
                    {...rest}
                >
                    {options.map((option) => (
                        <MenuItem key={option.display.toUpperCase()} value={option.value}>
                            <Checkbox checked={multiVal.indexOf(option.value) > -1} />
                            <ListItemText primary={option.display} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

function SelectNumberField(props) {
    const { label, filterName, updateParentState, options, ...rest } = props;
    const [val, setVal] = React.useState('');
    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const handleChange = (event) => {
        setVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <>
            <FormControl variant="outlined" className="fullWidth">
                <InputLabel ref={inputLabel} id="select-outlined-label">
                    {label}
                </InputLabel>
                <Select
                    labelId="select-outlined-label"
                    id="select-outlined"
                    value={val}
                    onChange={handleChange}
                    labelWidth={labelWidth}
                    {...rest}
                >
                    {options.map((option) => (
                        <MenuItem key={option.display.toUpperCase()} value={option.value}>
                            {option.display}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

function MultiSelectNumberField(props) {
    const { label, filterName, updateParentState, options, ...rest } = props;
    const [multiVal, setMultiVal] = React.useState([]);
    const inputLabel = React.useRef(null);

    const handleChange = (event) => {
        setMultiVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <>
            <FormControl className="fullWidth">
                <Select
                    labelId="mutiple-checkbox-label"
                    id="mutiple-checkbox"
                    multiple
                    value={multiVal}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.join(', ')}
                    {...rest}
                >
                    {options.map((option) => (
                        <MenuItem key={option.display.toUpperCase()} value={option.value}>
                            <Checkbox checked={multiVal.indexOf(option.value) > -1} />
                            <ListItemText primary={option.display} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

function MultiSelectizeText(props) {
    const { label, filterName, updateParentState, options, ...rest } = props;
    const [multiVal, setMultiVal] = React.useState([]);
    const inputLabel = React.useRef(null);

    const handleChange = (event) => {
        setMultiVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <>
            <FormControl className="fullWidth">
                <Select
                    labelId="demo-mutiple-name-label"
                    id="demo-mutiple-name"
                    multiple
                    value={multiVal}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    {...rest}
                >
                    {options.map((name) => (
                        <MenuItem key={name.toUpperCase()} value={name}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

export { SelectTextField, MultiSelectTextField, SelectNumberField, MultiSelectNumberField, MultiSelectizeText };
